/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VsLogsModule
 */

import {
    Directive,
    ElementRef,
    Input,
    OnInit,
    Renderer2,
} from '@angular/core';

import './vs-log-field-title.directive.less';

const componentSelector = 'vs-log-field-title';

/**
 * @description
 *     Direcitive used to set styles for the equal-width columns in VS log sections.
 * @author Zhiqian Liu
 */
@Directive({
    selector: '[vsLogFieldTitle]',
})
export class VsLogFieldTitleDirective implements OnInit {
    /**
     * Add a top margin if set to true or remove it otherwise.
     * Will be voided if the title is set to inline.
     */
    @Input()
    public withMarginTop ? = true;

    /**
     * If true, the title will be set to inline, the margin top will be shrinked, and a right
     * padding will be added.
     */
    @Input()
    public inline ? = false;

    /**
     * The native HTML element that the directive is bound to.
     */
    private domElement: HTMLElement;

    constructor(
        private readonly renderer: Renderer2,
        private readonly elementRef: ElementRef,
    ) {
        this.domElement = this.elementRef.nativeElement;
        this.renderer.addClass(this.domElement, componentSelector);
    }

    /** @override */
    public ngOnInit(): void {
        if (this.inline) {
            this.renderer.addClass(this.domElement, `${componentSelector}--inline`);
        } else if (this.withMarginTop) {
            this.renderer.addClass(
                this.domElement,
                `${componentSelector}__with-margin-top`,
            );
        }
    }
}
